import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Confetti - Celebration animation component
 * Non-breaking visual effect for success moments
 * Does not interfere with any logic
 */
const Confetti = ({ show = false, duration = 3000 }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (show) {
      const newParticles = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        x: Math.random() * window.innerWidth,
        color: ['#007AFF', '#AF52DE', '#FF2D55', '#FF9500', '#34C759'][Math.floor(Math.random() * 5)],
        delay: Math.random() * 0.5,
        duration: 2 + Math.random() * 2,
      }));
      setParticles(newParticles);

      const timer = setTimeout(() => setParticles([]), duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration]);

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      <AnimatePresence>
        {particles.map((particle) => (
          <motion.div
            key={particle.id}
            initial={{ 
              x: particle.x, 
              y: -20, 
              opacity: 1,
              rotate: 0 
            }}
            animate={{ 
              y: window.innerHeight + 20, 
              opacity: 0,
              rotate: 720 
            }}
            exit={{ opacity: 0 }}
            transition={{ 
              duration: particle.duration,
              delay: particle.delay,
              ease: 'easeIn'
            }}
            style={{
              position: 'absolute',
              width: '10px',
              height: '10px',
              backgroundColor: particle.color,
              borderRadius: '50%',
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Confetti;
